import { connect, MapStateToProps } from 'react-redux';
import { getProfileOwnerUser } from '../../../selectors/users';
import { getShopItemsStreamId } from '../../../streams/shop';
import { ShopItemType } from '../../../../types/shop';
import { AppState } from '../../../../types/store';
import { selectors as streamSelectors } from '@wix/da-shared-react/pkg/Stream';
import { Props } from './ShopSection';
import { flagEnabled } from '@wix/da-shared-react/pkg/redux/flags';

type StateProps = Pick<
  Props,
  'profileOwnerUser' | 'total' | 'withPremiumFolders'
>;
type OwnProps = Omit<Props, keyof StateProps>;

const mapStateToProps: MapStateToProps<
  StateProps,
  OwnProps,
  AppState
> = state => {
  const commissionsTotal = streamSelectors.getTotal(
    state,
    getShopItemsStreamId(ShopItemType.COMMISSIONS)
  );
  const premiumContentTotal = streamSelectors.getTotal(
    state,
    getShopItemsStreamId(ShopItemType.PREMIUM_CONTENT)
  );
  const printsTotal = streamSelectors.getTotal(
    state,
    getShopItemsStreamId(ShopItemType.PRINTS)
  );
  const premiumFoldersTotal = streamSelectors.getTotal(
    state,
    getShopItemsStreamId(ShopItemType.PREMIUM_FOLDERS)
  );

  let allTotal = commissionsTotal + premiumContentTotal + printsTotal;
  const withPremiumFolders = flagEnabled(state, 'premium_folders');
  if (withPremiumFolders) {
    allTotal += premiumFoldersTotal;
  }

  return {
    profileOwnerUser: getProfileOwnerUser(state),
    withPremiumFolders,
    total: {
      all: isNaN(allTotal) ? 0 : allTotal,
      commissions: commissionsTotal,
      premiumContent: premiumContentTotal,
      prints: printsTotal,
      premiumFolders: premiumFoldersTotal,
    },
  };
};

export default connect(mapStateToProps);
